export const DEFINE_USER = 'DEFINE_USER';
export const CLEAR_USER = 'CLEAR_USER';
export const DEFINE_ROOT = 'DEFINE_ROOT';
export const RECOVER_ROOT = 'RECOVER_ROOT';
export const DEFINE_HAS_LOGGED_OUT = 'DEFINE_HAS_LOGGED_OUT';
export const DEFINE_SESSION_USER_ROLE = 'DEFINE_SESSION_USER_ROLE';
